import React from "react";
import Placeholder from "react-bootstrap/Placeholder";

const GridRowCellLoadingIndicator = () => (
  <Placeholder
    style={{
      minWidth: "66%",
      backgroundColor: "#efefef",
      verticalAlign: "middle",
      height: "15px",
      display: "inline-block",
      margin: "0 auto",
      opacity: 1
    }}
  />
);

export default GridRowCellLoadingIndicator;
